import { defineStore } from "pinia"
import { NewsService } from "@/store/services/news.service.js"
import { storeToRefs } from "pinia"

export const newsStore = defineStore("news", {
  state: () => {
    return {
      latestNews: "",
    }
  },
  getters: {
    getLatestNews: (state) => state.latestNews,
  },
  actions: {
    getLatestNewsAction(page = 1, itemCount = 10) {
      if (this.latestNews != "") return this.latestNews
      EventSys.$emit("news_loading")
      NewsService.list(page, itemCount).then(({ data }) => {
        EventSys.$emit("news_loaded")
        this.latestNews = data.data
      })
    },
  },
})
